import clearFileProviderItems from './clearFileProviderItems';
import { incrementGetFileProviderItemsRequestCount } from './helpers/getFileProviderItemsRequestCount';
import { canCallFileProviderAPIFromClient } from 'owa-fileprovider-items-service';
import loadMoreItemsForSelectedProvider from './loadMoreItemsForSelectedProvider';
import setDefaultSort from './setDefaultSort';
import updateFilePickerPagingMetadata from './updateFilePickerPagingMetadata';
import updateFilePickerSelectedFolder from './updateFilePickerSelectedFolder';
import type FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import { logUsage } from 'owa-analytics';
import { ClientOnlyFileProviderType } from 'owa-fileprovider-store';
import { lazyClearSearchBox } from 'owa-search-actions';
import { SearchScenarioId } from 'owa-search-store';
import {
    FolderItemViewState,
    FileProviderItemType,
    GroupItemViewState,
} from '../store/schema/FileProviderItemViewState';

async function shouldClearMetadata(
    folder: FolderItemViewState | GroupItemViewState,
    viewState: FilePickerPanelViewState
): Promise<boolean> {
    if (folder && folder.type === FileProviderItemType.Folder) {
        let { key: lastFolderId = null } = viewState.filePickerViewState.selectedFolder || {};
        if (
            lastFolderId !== folder.key &&
            (await canCallFileProviderAPIFromClient(
                viewState.selectedFileProvider.type,
                viewState.selectedFileProvider.model
                    ? viewState.selectedFileProvider.model.EndPointUrl
                    : null,
                viewState.selectedProviderScope
            ))
        ) {
            return true;
        }
    }

    return false;
}

export default async function changeSelectedFolder(
    folder: FolderItemViewState | GroupItemViewState,
    viewState: FilePickerPanelViewState,
    isPrefetch: boolean = false
) {
    const isWeSpace: boolean =
        viewState.selectedFileProvider.viewType === ClientOnlyFileProviderType.Groups;
    logUsage('FPChangeSelectedFolder', [
        isWeSpace,
        viewState.selectedFileProvider.type,
        viewState.filePickerViewState.searchViewState.isInSearchMode,
    ]);

    if (folder && folder.type === FileProviderItemType.Group) {
        updateFilePickerPagingMetadata(viewState, folder.pagingMetadata);
    } else if (await shouldClearMetadata(folder, viewState)) {
        updateFilePickerPagingMetadata(viewState, null);
    } else {
        if (viewState.filePickerViewState.breadcrumbs.length <= 1) {
            updateFilePickerPagingMetadata(viewState, null);
        }
    }

    // Clear out of any search we were possibly doing. Note: We have to do this regardless of
    // if we are in a search or not, since we still want to reset the search state
    // if the user has typed in the search bar, but not started a search.
    const clearSearchBox = await lazyClearSearchBox.import();
    clearSearchBox(SearchScenarioId.FilesPicker);

    incrementGetFileProviderItemsRequestCount();
    updateFilePickerSelectedFolder(viewState, folder as FolderItemViewState);
    setDefaultSort(viewState.filePickerViewState);
    clearFileProviderItems(viewState.filePickerViewState);
    loadMoreItemsForSelectedProvider(viewState, false, isPrefetch);
}
